import React from 'react';
import PropTypes from 'prop-types';
import avatar from '~/assets/images/avatar.png';
import { Container, Body, Box } from './styles';

const PatientData = ({ showingData }) => {
  return (
    <Container>
      <header>
        <Box colorDark="true">
          Paciente:
          <span data-testid="patientName">
            {showingData?.patientName ?? '****'}
          </span>
        </Box>
        <Box colorDark="true">
          Data da receita:{' '}
          <span data-testid="date">{showingData?.date ?? '* * **'}</span>
        </Box>
      </header>
      <Body>
        <img src={avatar} alt="HIAE" />
        <div>
          <Box data-testid="doctorName" colorDark="true">
            <span data-testid="doctorArticle" style={{ fontSize: `larger` }}>
              {showingData?.doctorArticle}
            </span>
            {showingData?.doctorName ?? '***'}
          </Box>
          <Box data-testid="doctorData">
            <span data-testid="doctorClassCodeType">
              {showingData?.doctorClassCodeType ?? 'CRM'}
            </span>
            {showingData?.doctorClassCode ?? '**'}-
            {showingData?.doctorClassOrigin ?? '**'}
          </Box>
        </div>
      </Body>
    </Container>
  );
};

PatientData.propTypes = {
  showingData: PropTypes.shape({
    date: PropTypes.string,
    doctorArticle: PropTypes.string,
    doctorClassCode: PropTypes.string,
    doctorClassCodeType: PropTypes.string,
    doctorClassOrigin: PropTypes.string,
    doctorName: PropTypes.string,
    patientName: PropTypes.string,
  }),
};

PatientData.defaultProps = {
  showingData: null,
};

export default PatientData;
